module.exports = __webpack_public_path__ + "img/header-engagementRingsSignature@2x.d65216c.jpg";